module.exports = __webpack_public_path__ + "img/3.988bb0eb.jpg";